module.exports = __webpack_public_path__ + "img/excel.cd04c5ba.png";